export const FETCH_ALL_MODELS = "FETCH_ALL_MODELS";
export const FETCH_MODEL_BY_ID = "FETCH_MODEL_BY_ID";
export const FETCH_SPEECH_DATA = "FETCH_SPEECH_DATA";
export const FETCH_TRAINING_TYPES = "FETCH_TRAINING_TYPES";
export const CREATE_TRAINING_DATA = "CREATE_TRAINING_DATA";